var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.iconName && _vm.iconName.length > 0)?_c('v-img',{attrs:{"src":_vm.iconPath,"width":_vm.size,"eager":""},on:{"click":_vm.click}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }